export default {
  TOGGLE_DRAWER(state) {
    state.open = !state.open;
  }
};
